if ($("header#header").length) {


  $(".header-top").append($("#navigation").clone());
  $(".navigation-wrapper>#navigation").remove();

  $(".header-top").append($(".top-navigation-bar .responsive-tools").clone());
  const $cartBtn = $('.navigation-buttons a[data-target="cart"]').first().clone(false, false);
  $cartBtn.removeAttr("data-hover").attr("data-redirect", "false").appendTo(".header-top .responsive-tools");

  $('<span class="close"></span>').appendTo(".login-widget .popup-widget-inner #customerLogin");
 // if(!$('body.ordering-process').length){
      $(".header-top .responsive-tools").prepend('<span class="btn btn-third">Vybrat termín</span>');
 // }


  $(".responsive-tools>span.btn.btn-third").on("click", function () {
    $(".rezervace").toggleClass("visible");
  });
  $(".header-top .responsive-tools").prepend(`<div class="orderBox"><span class="obj">Objednávky na </span><span class="date">úterý 19.5.</span>
       <span class="left"> zbývá <span class="leftValue">03 hod 29 min </span></span>
        </div>`);

  if (window.innerWidth < 992) {
      $(".btn.btn-icon.toggle-window.cart-count").removeAttr("data-hover");
      $(".btn.btn-icon.toggle-window.cart-count").removeAttr("data-target");
      $(".btn.btn-icon.toggle-window.cart-count").removeClass("toggle-window");
    }
  function updateOrderBoxWrapper() {
    const isTargetRange = window.matchMedia("(min-width: 992px) and (max-width: 1199px)").matches;
    const $orderBox = $(".header-top .responsive-tools .orderBox");
    const $reservationButton = $(".header-top .responsive-tools .btn.btn-third");

    function toggleCustomWrapper($element) {
      if (!$element.length) {
        return;
      }

      if (isTargetRange) {
        if (!$element.parent().hasClass("customWrapper")) {
          $element.wrap('<div class="customWrapper"></div>');
        }
        return;
      }

      if ($element.parent().hasClass("customWrapper")) {
        $element.unwrap();
      }
    }

    toggleCustomWrapper($orderBox);
    toggleCustomWrapper($reservationButton);
  }

  updateOrderBoxWrapper();
  $(window).on("resize", updateOrderBoxWrapper);

  $(".header-top .search").append('<span class="close"></span>');

  $(document).on("click", ".header-top .search .close", function () {
    $("body").removeClass("search-window-visible");
  });

  $(".header-top .responsive-tools").append($(".header-top .site-name-wrapper").clone());
  $(document).on("click", ".login-widget .popup-widget-inner .close", function () {
    $("body").removeClass("user-action-visible login-window-visible");
  });

  $("ul.menu-level-2").wrapInner('<div class="subMenu"></div>');

  $(document).on("click", '.header-top .responsive-tools a[data-target="cart"]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#cart-widget").toggleClass("visible");
  });
  (function () { 
    function normalizePath(url) {
        try {
          const parsedUrl = new URL(url, window.location.origin);
          let path = parsedUrl.pathname;

          if (!path.startsWith("/")) {
            path = "/" + path;
          }

          if (!path.endsWith("/")) {
            path += "/";
          }

          return path;
        } catch (error) {
          return null;
        }
      }

      function replaceMenuImages() {
        const menu = document.querySelector(
          'ul.menu-level-2[aria-label="Rezervace pečiva"]'
        );

        if (!menu) {
          return;
        }

        const menuImageLinks = menu.querySelectorAll(
          "li > a.menu-image[href]"
        );

        menuImageLinks.forEach(function (link) {
          const categoryPath = normalizePath(link.getAttribute("href"));

          if (!categoryPath) {
            return;
          }

          const newImageUrl = categoryMenuImages[categoryPath];

          if (!newImageUrl) {
            return;
          }

          const image = link.querySelector("img");

          if (!image) {
            return;
          }

          image.src = newImageUrl;
          image.setAttribute("data-src", newImageUrl);

          // Pokud Shoptet nebo lazy-loading používá další atributy:
          image.setAttribute("data-original", newImageUrl);
          image.setAttribute("data-lazy-src", newImageUrl);
        });
      }

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", replaceMenuImages);
      } else {
        replaceMenuImages();
      }
  })();
}
